<script>
export default {
  props: {
    title: { type: String, required: true },
    value: { type: [String, Number], default: '' },
    compact: { type: Boolean, default: false },
  },
  computed: {
    containerClasses() {
      if (this.compact) {
        return 'py-0 px-0 bg-transparent dark:bg-transparent';
      }
      return 'py-2 px-0 bg-slate-50 dark:bg-slate-800 rounded-xl';
    },
  },
};
</script>

<template>
  <div class="overflow-auto" :class="containerClasses">
    <div class="items-center flex justify-between mb-1">
      <span class="text-xs font-medium text-slate-600 dark:text-slate-400">
        {{ title }}
      </span>
      <slot name="button" />
    </div>
    <div v-if="value" class="break-words text-sm text-slate-800 dark:text-slate-200">
      <slot>
        {{ value }}
      </slot>
    </div>
  </div>
</template>
